var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app-ps",class:{ 'app__bg--white': _vm.hasBackgroundImg }},[_c('TheHeader'),_c('main',[_c('router-view')],1),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }